import { render, staticRenderFns } from "./InboxDropdownItem.vue?vue&type=template&id=13fceecc&scoped=true&"
import script from "./InboxDropdownItem.vue?vue&type=script&lang=js&"
export * from "./InboxDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./InboxDropdownItem.vue?vue&type=style&index=0&id=13fceecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fceecc",
  null
  
)

export default component.exports